/* Millo Coins en toda la web (13-oct-2026, Edgar: «la Millo Coin es la moneda de todo el mundo de Bryant Myers;
   su logo tiene que estar en la bolsa y en todo»). Sirve igual para la maqueta y para el tema de Shopify.
   - Cabecera: siempre abre el perfil Millo Coins. Su puerta comprueba la membresía; los miembros activos conservan la moneda y el saldo.
   - Fichas: «Ganas X Millo Coins con esta compra» bajo el precio (1 € = 1 coin, membresía básica). 29-oct-2026 (Edgar): antes «+X Millo Coins…»;
     la misma frase en la ficha de ropa y en la de los bolsos exclusivos.
   - Bolsa: «+X Millo Coins con este pedido» encima del subtotal.
   El panel confirma el saldo de la cuenta en todas las páginas; los metacampos son solo la copia inicial.
   window.MG_COINS.auth contiene la firma de la sesión, nunca la clave de la tienda. */
(function () {
  'use strict'
  var D = window.MG_COINS = window.MG_COINS || {}
  var base = (document.querySelector('script[src*="mg-coins.js"]') || {}).src || ''
  base = base.replace(/mg-coins\.js.*$/, '')
  var COIN = D.coin || (base + 'mg-coin-64.png')
  var EN = (document.documentElement.lang || '').indexOf('en') === 0 || /[?&]lang=en/.test(location.search)
  var cliente = !!D.auth || ('saldo' in D && D.saldo !== null)
  var saldo = null, ganados = null, confirmado = false, sincronizacion = cliente ? 'loading' : 'visitor'
  var enCurso = null, proximaConsulta = 0, requiereRecarga = false, esperaError = 30000
  /* 14-oct: miembro al día = 1,5 Millo Coins por euro (panel, club.py); sin membresía, 1. La cuota de la membresía suma 1 por euro. */
  var SOCIO = D.socio === true, X = 1.5
  var clubUrl = D.club || (base.replace(/assets\/$/, '') + 'products/millo-gang-membership/index.html')
  var loginUrl = D.login || clubUrl
  /* La cabecera siempre abre el perfil; su puerta verifica la membresía por separado. */
  var profileRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
  if (!profileRoot && window.MG && window.MG.routes && window.MG.routes.cart) profileRoot = String(window.MG.routes.cart).replace(/\/cart\/?$/, '/')
  if (typeof profileRoot !== 'string' || profileRoot.charAt(0) !== '/' || profileRoot.charAt(1) === '/') profileRoot = '/'
  var profileUrl = D.perfil || profileRoot.replace(/\/?$/, '/') + 'pages/millo-club'
  function fmt(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, EN ? ',' : '.') }
  function coin(cls) { return '<img class="' + (cls || 'mgc-i') + '" src="' + COIN + '" alt="" width="64" height="64" aria-hidden="true">' }
  function eur(t) { /* «3.900 €», «449,00 €», «30,00 €», «$30.00» -> número */
    if (!t) return 0
    var m = t.replace(/\s/g, ' ').match(/([0-9][0-9.,]*)/)
    if (!m) return 0
    var s = m[1]
    if (/,\d{2}$/.test(s)) s = s.replace(/\./g, '').replace(',', '.')
    else if (/\.\d{2}$/.test(s)) s = s.replace(/,/g, '')
    else s = s.replace(/[.,]/g, '')
    return parseFloat(s) || 0
  }

  function numero(n) { return typeof n === 'number' && Number.isFinite(n) && n >= 0 }
  function texto(el, value) { if (el && el.textContent !== value) el.textContent = value }
  function avisoSaldo() {
    if (sincronizacion === 'error') return requiereRecarga
      ? (EN ? 'Reload the page to update your balance.' : 'Recarga la página para actualizar tu saldo.')
      : (EN ? 'Balance could not be updated.' : 'No se ha podido actualizar tu saldo.')
    if (!confirmado) return EN ? 'Checking your Millo Coins…' : 'Consultando tus Millo Coins…'
    return ''
  }

  /* 1) cabecera: nunca confundir un saldo pendiente de consultar con cero. */
  function cabecera() {
    document.querySelectorAll('.bagbtn').forEach(function (b) {
      var a = b.previousElementSibling
      if (!a || !a.classList.contains('mgc-h')) {
        a = document.createElement('a'); a.className = 'mgc-h'; b.parentNode.insertBefore(a, b)
      }
      var firma = [cliente, SOCIO, confirmado, saldo, sincronizacion, requiereRecarga].join(':')
      if (a.getAttribute('data-mgc-render') === firma) return
      a.setAttribute('data-mgc-render', firma)
      a.setAttribute('data-millo-state', sincronizacion)
      a.href = profileUrl
      if (!SOCIO) {
        a.innerHTML = '<span>Millo Coins</span>';
        a.setAttribute('aria-label', EN ? 'Your Millo Coins profile' : 'Tu perfil de Millo Coins');
      } else {
        a.innerHTML = coin() + '<b>' + (confirmado ? fmt(saldo) : '…') + '</b>';
        var label = confirmado ? (EN ? 'Your Millo Coins: ' : 'Tus Millo Coins: ') + fmt(saldo) : avisoSaldo();
        if (confirmado && sincronizacion === 'error') label += '. ' + avisoSaldo();
        a.setAttribute('aria-label', label);
      }
      a.title = SOCIO ? avisoSaldo() : (EN ? 'Your Millo Coins profile' : 'Tu perfil de Millo Coins')
    })
  }

  /* Los bolsos se desbloquean por coins ganados, no por el saldo disponible. */
  function bolsos() { /* Public monetary purchases do not depend on Coins. */ }

  /* 2) fichas: bajo el precio principal */
  function fichas() {
    if (!SOCIO) { document.querySelectorAll('.mgc-earn').forEach(function(e){e.remove()}); return; }
    document.querySelectorAll('.card2 .pr-w').forEach(function (w) {
      if (/membership/.test(location.pathname)) return
      var pr = w.querySelector('.pr'); if (!pr) return
      var n = Math.floor(eur(pr.textContent) * (SOCIO ? X : 1)); if (!n) return
      var p = w.nextElementSibling && w.nextElementSibling.classList.contains('mgc-earn') ? w.nextElementSibling : null
      var html = coin() + '<span>' + (EN ? 'Earn ' : 'Ganas ') + '<b>' + fmt(n) + '</b> Millo Coins ' + (EN ? 'with this purchase' : 'con esta compra') + '</span>'
      if (!p) { p = document.createElement('p'); p.className = 'mgc-earn'; w.parentNode.insertBefore(p, w.nextSibling) }
      if (p.getAttribute('data-n') !== String(n)) { p.innerHTML = html; p.setAttribute('data-n', n) }
    })
    /* bolsos exclusivos: bajo «3.900 € · Exclusivo» */
    document.querySelectorAll('.mgg-pr').forEach(function (r) {
      var n = Math.floor(eur(r.firstElementChild && r.firstElementChild.textContent) * (SOCIO ? X : 1)); if (!n) return
      var p = r.nextElementSibling && r.nextElementSibling.classList.contains('mgc-earn') ? r.nextElementSibling : null
      if (!p) { p = document.createElement('p'); p.className = 'mgc-earn'; r.parentNode.insertBefore(p, r.nextSibling) }
      if (p.getAttribute('data-n') !== String(n)) { p.innerHTML = coin() + '<span>' + (EN ? 'Earn ' : 'Ganas ') + '<b>' + fmt(n) + '</b> Millo Coins ' + (EN ? 'with this purchase' : 'con esta compra') + '</span>'; p.setAttribute('data-n', n) }
    })
  }

  /* 3) bolsa: encima del subtotal. Ropa a 1,5 si eres miembro o la membresía va en la bolsa (ese pedido ya cuenta como miembro); la cuota, 1 por euro */
  function bolsa() {
    if (!SOCIO) { document.querySelectorAll('.mgc-bag').forEach(function(e){e.remove()}); return; }
    document.querySelectorAll('.bf').forEach(function (bf) {
      var row = bf.querySelector('.row')
      var old = bf.querySelector('.mgc-bag')
      if (!row) { if (old) old.remove(); return }
      var total = 0, cuota = 0, recarga = 0, mem = false
      var bag = bf.closest('.bag, [class*="bag"]') || document
      bag.querySelectorAll('.items .it').forEach(function (it) {
        if (it.classList.contains('it--coins')) { recarga += Number(it.getAttribute('data-millo-base')) || 0; return }
        var p = it.querySelector('.p'); if (!p) return
        var t = p.lastChild ? p.lastChild.textContent : p.textContent
        if (it.classList.contains('it--mem')) { mem = true; cuota += eur(t); return }
        total += eur(t)
      })
      var n = Math.floor(total * (SOCIO || mem ? X : 1)) + Math.floor(cuota) + Math.floor(recarga * (SOCIO || mem ? X : 1))
      if (!n) { if (old) old.remove(); return }
      var html = coin() + '<span><b>+' + fmt(n) + '</b> Millo Coins ' + (EN ? 'with this order' : 'con este pedido') + '</span>' +
        (!cliente ? '<a href="' + loginUrl + '">' + (EN ? 'Log in to keep them' : 'Inicia sesión para guardarlos') + '</a>' : '<em>' + (EN ? 'You will have ' : 'Tendrás ') + (confirmado ? fmt(saldo + n) : '…') + '</em>')
      if (!old) { old = document.createElement('div'); old.className = 'mgc-bag'; bf.insertBefore(old, bf.firstChild) }
      old.title = avisoSaldo()
      var firma = String(n) + ':' + String(saldo) + ':' + String(confirmado)
      if (old.getAttribute('data-n') !== firma) { old.innerHTML = html; old.setAttribute('data-n', firma) }
    })
  }

  function todo() { cabecera(); fichas(); bolsa(); bolsos() }
  function estadoCarga(estado) {
    sincronizacion = estado; D.estado = estado; D.requiereRecarga = requiereRecarga
    document.dispatchEvent(new CustomEvent('millo:estado-carga', {detail: {estado: estado, recarga: requiereRecarga}}))
    todo()
  }
  document.addEventListener('millo:estado', function(e) {
    var estado = e.detail || {}
    if (estado.ok !== true || !numero(estado.saldo)) return
    saldo = estado.saldo; confirmado = true; sincronizacion = 'ready'
    if (numero(estado.ganados)) ganados = estado.ganados
    if (typeof estado.miembro_activo === 'boolean') SOCIO = estado.miembro_activo
    D.saldo = saldo; D.socio = SOCIO; D.confirmado = true; D.estado = 'ready'
    if (numero(ganados)) D.ganados = ganados
    if (typeof estado.miembro_activo === 'boolean') D.miembro_activo = SOCIO
    D.confirmadoEn = Date.now()
    todo()
  })

  /* Una sola petición por página; volver a una pestaña confirma de nuevo el saldo real.
     Errores y límites de consulta conservan el último saldo confirmado, jamás inventan cero. */
  function refrescar() {
    var review=window.MG_COINS_POLICY;
    if(review && review.simulated){
      var simulated={ok:true,saldo:Number(D.saldo)||0,ganados:Number(D.ganados)||0,miembro_activo:review.active};
      document.dispatchEvent(new CustomEvent('millo:estado',{detail:simulated}));
      return Promise.resolve(simulated);
    }
    var auth = D.auth
    if (!cliente) return Promise.resolve(null)
    if (enCurso) return enCurso
    if (requiereRecarga || Date.now() < proximaConsulta) return Promise.resolve(null)
    if (!auth || !auth.api || !auth.c || !auth.ts || !auth.f) {
      requiereRecarga = true; estadoCarga('error'); return Promise.resolve(null)
    }
    proximaConsulta = Date.now() + 5000
    estadoCarga('loading')
    var controller = window.AbortController ? new window.AbortController() : null
    var timer, esperaRespuesta = 0
    var timeout = new Promise(function(resolve, reject) {
      timer = setTimeout(function() { if (controller) controller.abort(); reject(new Error('estado-timeout')) }, 10000)
    })
    var options = {method: 'POST', cache: 'no-store', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({c: auth.c, ts: auth.ts, f: auth.f, tipo: 'estado'})}
    if (controller) options.signal = controller.signal
    var consulta = Promise.resolve().then(function() { return fetch(auth.api, options) }).then(function(response) {
      if (response.status === 401) { requiereRecarga = true; throw new Error('estado-auth') }
      if (response.status === 429) {
        var retry = response.headers && response.headers.get('Retry-After')
        esperaRespuesta = Number(retry) > 0 ? Number(retry) * 1000 : Math.max(60000, Date.parse(retry) - Date.now() || 0)
        throw new Error('estado-limite')
      }
      if (!response.ok) throw new Error('estado-http')
      return response.json().then(function(estado) {
        if (!estado || estado.ok !== true || !numero(estado.saldo)) throw new Error('estado-datos')
        return estado
      })
    })
    enCurso = Promise.race([consulta, timeout]).then(function(estado) {
      esperaError = 30000
      document.dispatchEvent(new CustomEvent('millo:estado', {detail: estado}))
      return estado
    }).catch(function() {
      proximaConsulta = Math.max(proximaConsulta, Date.now() + Math.max(esperaError, esperaRespuesta))
      esperaError = Math.min(300000, esperaError * 2)
      estadoCarga('error')
      return null
    }).then(function(estado) { clearTimeout(timer); enCurso = null; return estado })
    return enCurso
  }
  D.refresh = refrescar
  function volver() { if (!document.hidden) refrescar() }
  document.addEventListener('visibilitychange', volver)
  window.addEventListener('pageshow', function(event) { if (event.persisted) volver() })
  window.addEventListener('focus', volver)
  window.addEventListener('online', volver)
  setInterval(volver, 30000)
  var pend = 0
  new MutationObserver(function () { if (pend) return; pend = requestAnimationFrame(function () { pend = 0; todo() }) })
    .observe(document.documentElement, { childList: true, subtree: true, characterData: true })
  function iniciar() { todo(); volver() }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar()
})()
